import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const AuthenticationContainer = styled.div`
  background-color: ${({ theme }: any) => theme.colors.greyscale.white};
  padding: ${rem(32)};
  border-radius: ${rem(4)};
  min-height: ${rem(448)};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
